<template>

  <!-- 1st Hero Variation -->
  <section class="section second_section" style="padding-bottom: 100px;">
    <div class="section_header mobile_div d-flex justify-content-center"  v-if="is_load">
      <nav aria-label="breadcrumb" v-if="is_load">
        <ol class="breadcrumb">
           <li class="breadcrumb-item"><router-link tag="a" to="/leads" >Все сделки</router-link></li>
          <li class="breadcrumb-item"><router-link tag="a" :to="'/funnel/'+lead.funnel_id" >{{ lead.funnel.title}}</router-link></li>
          <li class="breadcrumb-item active" aria-current="page">Сделка #{{lead.id}}</li>
        </ol>
      </nav>
    </div>

    <loading-block v-if="is_load==false && is_load_error==false" :loading="!is_load"/>
    <div class="container-fluid" v-if="is_load==false && is_load_error==true">
      <div class="alert alert-warning">
        <h2>Ошибка</h2>
        <p>{{ load_error}}</p>
      </div>

    </div>
    <div   style="" shadow  v-if="is_load"

          class="container-fluid">
      <div  >


        <div class="row"  v-if="is_load==true">

        <div class="col-12 col-md-4 col-lg-4 block_row">
          <div  class="well" style="" shadow>




              <div>

                  <h4>Статус верификации</h4>

                <div v-if="lead.user_id==null && link_tg_verification">
                  <div class="form-group">
                    <label class="badge">Не верифицирован!</label>
                    <p>Ссылка на верификацию</p>
                     <textarea class="form-control textarea_add_lead" readonly>{{ link_tg_verification }}</textarea>
                  </div>
                </div>
                <div v-if="lead.user_id!=null" class="ml-4 mt-4">
                  <p>id {{ lead.client.telegram_id}}</p>
                  <p v-if="lead.client.username">username <a :href="'https://t.me/'+lead.client.username" target="_blank">@{{lead.client.username}}</a></p>
                </div>
            </div>





            <div class="card_in_lead">

              <div  class="lead_info">
                <div class="ml-4 mt-4 mb-4">
                  <h4>Основная информация</h4>
                </div>

                <div>

                  <div class="form-group">
                    <label>Воронка/Статус</label>
                    <select class="form-control" v-model="lead.status_id" @change="changeStatus">
                      <option   v-if="statuses.length>0" v-for="status in statuses" :value="status.last_id"
                              :key="status.last_id">{{status.funnel.title}}/{{
                          status.title
                        }}
                      </option>
                    </select>
                  </div>
                </div>

                <div>
                  <div class="form-group">
                    <vue-tags-input
                        v-model="tag"
                        :tags="tags"
                        @tags-changed="tagsChanged" placeholder="Введите новый тег"
                    />


                  </div>
                </div>

                <div>
                  <div class="form-group">
                    <label>Ответственный</label>
                    <select class="form-control" @change="changeResponsible" v-model="lead.responsible_id">
                      <option v-if="users.length>0" v-for="user in users" :value="user.last_id"
                              :key="user.last_id">{{
                          user.name
                        }}
                      </option>
                    </select>
                  </div>
                </div>




              </div>



            </div>

          </div>

          <div class="card_in_lead">
            <div class="lead_info">
              <div>Основные данные</div>


              <div>



                <div class="form-group " style="display:inline-block;">
                  <button style="display:inline-block;" :class="{'btn-active':current_tab==0,'btn_no_choose':!(current_tab==0)}" class="btn " @click="changeCurrentTab(0);">Основная</button>

                    <button style="display:inline-block;" v-for="(tab,field_index) in tabs" :class="{'btn-active':current_tab==tab.id,'btn_no_choose':!(current_tab==tab.id)}" class="btn m-2" @click="changeCurrentTab(tab.id);"   v-html="tab.title"></button>

                </div>
              </div>

              <div v-if="lead.lead_data.length>0 & is_edit_lead==false & field.tab_id==current_tab" v-for="(field,field_index) in lead.lead_data"
                             :key="field.last_id">
                <div class="form-group"  >
                  <label  >{{ field.title}} </label>
                  <p style="display:inline;" v-if="!(field.type=='phone' || field.type=='email' || field.type=='vk')"> {{ lead.lead_data[field_index].value }}</p>
                  <p style="display:inline" v-if="field.type=='phone'">
                    <a :href="'tel:'+lead.lead_data[field_index].value">{{ lead.lead_data[field_index].value }}</a>
                  </p>
                  <p style="display:inline" v-if="field.type=='email'">
                    <a :href="'mailto:'+lead.lead_data[field_index].value" target="_blank"> {{ lead.lead_data[field_index].value }}</a>
                  </p>
                  <p style="display:inline" v-if="field.type=='vk'">
                    <a :href="lead.lead_data[field_index].value" target="_blank">{{ lead.lead_data[field_index].value }}</a>

                  </p>




                </div>
              </div>
              <div class="row mt-2 mb-2" v-if="is_edit_lead==false">
                <p><button class="btn side4 save_lead_btn" @click="showForm()">Изменить данные</button></p>
              </div>
              <div v-if="lead.lead_data.length>0 & is_edit_lead==true & field.tab_id==current_tab" v-for="(field,field_index) in lead.lead_data"
                             :key="field.last_id">
          <div class="form-group"  >
            <label  >{{ field.title}} </label>

            <input type="text" v-if="field.type=='string' || field.type=='phone' || field.type=='email' || field.type=='vk' "  class="form-control" v-model="lead.lead_data[field_index].value"
            />
            <input type="file" v-if="field.type=='image' || field.type=='file'"  class="form-control"
            />
            <input type="number" v-if="field.type=='integer'"  class="form-control" v-model="lead.lead_data[field_index].value"
            />
            <textarea v-if="field.type=='textarea'" class="form-control textarea_add_lead" v-model="lead.lead_data[field_index].value"></textarea>
            <select    v-if="field.type=='select'" class="form-control"   v-model="lead.lead_data[field_index].value">
              <option v-if="field.options.length>0" v-for="(option2,index2) in field.options"
                      :key="option2" :value="option2"  v-bind:value="option2">{{option2}}</option>
            </select>

            <select  multiple="multiple" v-if="field.type=='multi'" class="form-control" v-model="lead.lead_data[field_index].value">
              <option v-if="field.options.length>0" v-for="(option,index) in field.options"
                      :key="index" :value="option" v-bind:value="option">{{ option}}</option>
            </select>



          </div>
              </div>

          <div class="row" v-if="is_edit_lead==true">
            <div class="col-12 ">
              <p><button class="btn side4 save_lead_btn" @click="saveLead()">Сохранить </button></p>
            </div>
            <div class="col-12">
              <p><button class="btn" @click="hideForm()">Отмена</button></p>
            </div>

          </div>
            </div>
          </div>
        </div>

          <div class="col-12 col-md-8 col-lg-8 block_row">
            <ul class="nav lead_top_nav">
              <li class="nav-item">
                <a class="nav-link " :class="{'active':top_nav_bar_action=='history'}" @click="changeTopNavBar('history')">История изменений</a>
              </li>
              <li class="nav-item" v-if="categorys.length>0">
                <a class="nav-link" :class="{'active':top_nav_bar_action=='com_edit'}" @click="changeTopNavBar('com_edit')" >Коммерческое предложение</a>
              </li>
<!--              <li class="nav-item">-->
<!--                <a class="nav-link"  :class="{'active':top_nav_bar_action=='projects'}" @click="changeTopNavBar('projects')">Проекты лида</a>-->
<!--              </li>-->

            </ul>
            <div class="clearfix"></div>
            <div class="row" v-if="top_nav_bar_action=='projects'">
              <div class="col-12 col-md-12 col-lg-12" v-if="projects.length>0">

                <div class="row mt-2"

                     v-for="(project,project_index) in projects" :key="project.last_id">
                  <div class="col-12 col-md-7 col-lg-7 text-truncate">
                    <router-link class="text-clip" :to="{name: 'project', params: { id: project.last_id }}">
                      <base-button type="primary" class="text-clip" v-html="project.name_project">


                      </base-button>
                    </router-link>
                  </div>
                  <div class="col-12  col-md-3 col-lg-3">

                    <badge pill type="info" v-if="project.status_row.issearch==1">{{ project.status_row.title }}</badge>
                    <badge pill type="warning" v-if="project.status_row.iswork==1">{{ project.status_row.title }}
                    </badge>
                    <badge pill type="success" v-if="project.status_row.isfinish==1">{{ project.status_row.title }}
                    </badge>
                  </div>
                  <div class="col-12 col-md-2 col-lg-2">
                    <router-link :to="{name: 'project', params: { id: project.last_id }}"
                                 class="mb-3 mb-sm-0 btn side4">
                      <i
                          class="ni ni-bold-right"></i>
                    </router-link>

                  </div>


                </div>





              </div>
              <div class="col-12 col-md-12 col-lg-12" v-if="projects.length==0">
                <h4>Увы пользователь еще не перешел по ссылке и не подтвердил проект</h4>
              </div>
            </div>
            <div class="row"  v-if="top_nav_bar_action=='com_edit' && categorys.length>0 ">
              <div class="col-12">
                <div class="card_in_lead">
                  <div class="lead_info">
                    <div-meta class="ml-4 mt-4 mb-4">
                      <h4>Коммерческое предложение</h4>
                    </div-meta>

                    <div class="col-12" v-if="categorys.length>0">
                      <p v-if="lead.category_id>0">Что будет после того как клиент подтвердит создание проекта по ссылке</p>
                      <div class="form-group ml-4 " v-if="categorys.length>0">
                      <select class="form-control" @change="saveLead()" v-if="lead.category_id>0"  v-model="lead.developer_username">
                        <option :value="undefined">будет обьявлен конкурс</option>
                        <option v-if="developers.length>0" v-for="developer_select in developers" :value="developer_select.username"
                            :key="developer_select.last_id">назначить исполнителя {{
                            developer_select.name
                          }}
                        </option>
                      </select>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group " v-if="categorys.length>0">
                        <label>Услуга</label>
                        <select class="form-control"  @change="saveLead()" v-model="lead.category_id">
                          <option v-if="categorys.length>0" v-for="category in categorys" :value="category.last_id"
                              :key="category.last_id">{{
                              category.name
                            }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group " v-if="categorys.length>0">
                        <label>Валюта</label>
                        <select class="form-control"  @change="saveLead()" v-model="lead.currency">
                          <option v-if="categorys.length>0" v-for="currency in currencys" :value="currency"
                              :key="currency">{{
                              currency
                            }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group " v-if="categorys.length>0">
                        <label>Тип оплаты</label>
                        <select class="form-control"  @change="saveLead()" v-model="lead.type_invoice">
                          <option value="one">разовая</option>
                          <option value="every_month">каждый месяц</option>
                          <option value="every_year">каждый год</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group " v-if="categorys.length>0">
                        <label>Сумма сделки</label>
                        <input class="form-control" type="number" v-model="lead.sum" @change="saveLead()"/>

                      </div>
                     </div>
                    <div class="col-12">
                      <div class="form-group" v-if="categorys.length>0">
                        <label>Описание счета</label>
                        <textarea class="form-control" type="text" v-model="lead.invoice_title" ></textarea>

                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group ml-4 mt-4 mb-4" v-if="categorys.length>0">

                        <button class="btn" @click="saveLead()">Сохранить</button>

                      </div>
                    </div>
                    <div class="ml-4 mt-4 mb-4" v-if="lead.category_id && lead.category_id>0">
                      <p>Ссылка для клиента</p>
                      <textarea class="form-control" readonly>{{ lead.link}}</textarea>

                    </div>
                    <div class="ml-4 mt-4 mb-4" v-if="lead.category_id>0 && link_tg_on_offer_project">
                      <p>Ссылка для Telegram</p>
                       <textarea class="form-control" readonly>{{ link_tg_on_offer_project }}</textarea>



                    </div>

                    <div class="ml-4 mt-4 mb-4" v-if="lead.user_id && lead.user_id!=null && lead.category_id>0">
                      <p><button type="button" @click="sendLinkToClient()" class="btn">Отправить ссылку<br>клиенту</button></p>

                    </div>



                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-12">
                <editorjsinput :blocks_json="lead.project_data.blocks" ref="editorjs" ></editorjsinput>
                <div class="alert alert-danger" v-if="iserror_offer==true">
                  <p>{{ error_offer_message }}</p>
                </div>
                <base-button  @click="onSaveOffer" >Редактировать </base-button>
              </div>
            </div>
            <div class="row" v-if="top_nav_bar_action=='history'">
              <div class="col-12">
                <select class="form-control" v-model="history_type">
                  <option value="all">Показывать все</option>
                  <option value="changes">Только изменения</option>
                  <option value="tasks">Только задачи</option>
                  <option value="comments">Только комментарии</option>
                  <option value="messages">Только сообщения</option>
                </select>
              </div>
              <div class="col-12"  v-if="all_objects.length>0"   v-for="(lead_object,lead_object_key) in all_objects" :key="lead_object_key">
              <div class="row history_mini_card" v-if="lead_object.type_object=='history' && (history_type=='all' || history_type=='changes')">
                <div class="col-12 col-md-3">

                 <p>{{ lead_object.user.name}}</p>
                 <p><i class="fa fa-calendar-o"></i> {{ lead_object.created_at}}</p>
                </div>
                <div class="col-12 col-md-9">
                  <p>{{ lead_object.description}}</p>
                  <p v-if="lead_object.old_value">было:{{lead_object.old_value}}</p>
                  <p v-if="lead_object.new_value">стало:{{lead_object.new_value}}</p>
                </div>
              </div>
              <div class="row history_mini_card" v-if="lead_object.type_object=='comment' && (history_type=='all' || (history_type=='comment' && lead_object.is_telegram==0) || (history_type=='messages' && lead_object.is_telegram==1))">
                <div class="col-12 col-md-3">

                  <p>{{ lead_object.user.name}}</p>
                  <p><i class="fa fa-calendar-o"></i> {{ lead_object.created_at}}</p>
                </div>
                <div class="col-12 col-md-9">
                  <p v-if="lead_object.is_telegram==1">[сообщение]</p>
                  <p v-if="lead_object.is_telegram==0">[комментарий]</p>
                  <p style="white-space: pre-line"> {{ lead_object.comment}}</p>
                </div>
              </div>
               <div class="row history_mini_card" v-if="lead_object.type_object=='task' && (history_type=='all' || history_type=='tasks')">
                 <div class="col-12 col-md-3">
                   <p>{{ lead_object.create_user.name }}</p>
                 </div>
                 <div class="col-12 col-md-9">
                   <p>[задача]</p>
                   <p>{{ lead_object.type.title }}:{{ lead_object.text_task }}</p>

                   <p v-if="lead_object.is_complete==0">Выполнить до:{{ lead_object.date_to }}</p>
                   <p>Ответственный:{{ lead_object.responsible_user.name }}</p>
                   <p v-if="lead_object.is_complete==1">Результат: {{ lead_object.complete}} {{ lead_object.updated_at}}</p>
                   <div class="row" v-if="lead_object.is_complete==0">
                     <div class="col-12">
                       <div class="form-group">
                         <label>Введите результат</label>
                         <input class="form-control result_field" type="text" v-model="task_results[lead_object.id]" />

                       </div>

                     </div>
                     <div class="row col-12">
                       <div class="col-md-5 col-12">
                         <button class="btn" type="button" @click="setFinishTask(lead_object.id)">Выполнено</button>

                       </div>
                       <div class="col-md-5 col-12">
                         <button class="btn" type="button" @click="deleteTask(lead_object.id)">Удалить</button>

                       </div>
                     </div>



                   </div>
                 </div>
               </div>

              </div>

            </div>
            <ul class="nav lead_top_nav mt-5">
              <li class="nav-item">
                <a class="nav-link " :class="{'active':top_nav_sub_action=='addcomment'}" @click="changeActionNavBar('addcomment')">Добавить комментарий</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="{'active':top_nav_sub_action=='addtask'}" @click="changeActionNavBar('addtask')" >Добавить задачу</a>
              </li>
              <li class="nav-item" v-if="isemail==true">
                <a class="nav-link" :class="{'active':top_nav_sub_action=='write_email'}" @click="changeActionNavBar('write_email')" >Написать email</a>
              </li>

              <li class="nav-item" v-if="lead.user_id!=null">
                <a class="nav-link"  :class="{'active':top_nav_sub_action=='projects'}" @click="changeActionNavBar('answerclient')">Ответить клиенту</a>
              </li>

            </ul>
            <div class="clearfix"></div>
            <div class="col-12 row mt-5" v-if="top_nav_sub_action=='answerclient'">

              <h3   is="sui-header" dividing>Написать клиенту</h3>
              <div class="alert alert-danger" v-if="new_comment_is_error==true">
                <p>{{ new_comment_error }}</p>
              </div>


              <div class="row col-12 pt-2 pb-2" >
                <div class="col-md-8">
                  <label for="exampleTitle">Сообщение </label>
                  <textarea v-model="newComment.comment"
                      placeholder="Введите сообщение"></textarea>

                </div>
                <div class="col-md-4">


                  <button class=" btn side4 lead_add_comment_btn" v-if="lead.user_id!=null" @click="sendCommentTelegram">Ответить клиенту</button>
                </div>
              </div>



            </div>
            <div class="col-12 row mt-5" v-if="top_nav_sub_action=='write_email'">





              <div class="alert alert-danger" v-if="write_email_is_error==true">
                <p>{{ write_email_error }}</p>
              </div>


              <div class="row pt-2 pb-2" >
                <div class="col-md-12">
                  <label>Тема письма</label>
                  <input class="form-control" type="text" placeholder="Введите тему письма" v-model="newemail.subject" />




                </div>
                <div class="col-md-12">



                    <label for="exampleTitle">Текст письма </label>

                    <textarea class="form-control black_textarea" v-model="newemail.text" placeholder="Введите текст письма"></textarea>





                  <label for="exampleTitle"></label>
                  <button class=" btn side4 lead_add_comment_btn" @click="sendEmail">Отправить письмо</button>



                </div>
              </div>
            </div>


            <div class="col-12 row mt-5" v-if="top_nav_sub_action=='addtask'">





              <div class="alert alert-danger" v-if="new_task_is_error==true">
                <p>{{ new_task_error }}</p>
              </div>


              <div class="row pt-2 pb-2" >
                <div class="col-md-7">
                  <label for="exampleTitle">Текст задачи </label>
                  <textarea class="form-control" required id="exampleTitle"  v-model="newtask.text" placeholder="Введите комментарий"></textarea>


                  <div class="row">
                    <div class="col-md-5">
                      <div class="form-group">
                        <label>Ответственный</label>
                        <select class="form-control"   v-model="newtask.responsible_id">
                          <option v-if="users.length>0" v-for="user in users" :value="user.last_id"
                                  :key="user.last_id">{{
                              user.name
                            }}
                          </option>
                        </select>
                      </div>

                    </div>
                    <div class="col-md-5">
                      <div class="form-group">
                        <label>Тип задачи</label>
                        <select class="form-control"  v-model="newtask.type_id" >
                          <option   v-if="task_types.length>0" v-for="task_type in task_types" :value="task_type.last_id"
                                    :key="task_type.last_id">{{task_type.title}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>


                </div>
                <div class="col-md-4">


                  <div class="form-group">
                    <label>Выполнить до</label>
                    <input class="form-control" type="datetime-local" v-model="newtask.date_to" />

                  </div>

                  <label for="exampleTitle"></label>
                  <button class=" btn side4 lead_add_comment_btn" @click="sendTask">Опубликовать</button>



                </div>
              </div>
            </div>
            <div class="col-12  mt-5" v-if="top_nav_sub_action=='addcomment'">
              <h3>Написать комментарий</h3>
            </div>
            <div class="col-12 row lead_add_comment mt-5" v-if="top_nav_sub_action=='addcomment'">





              <div class="alert alert-danger" v-if="new_comment_is_error==true">
                <p>{{ new_comment_error }}</p>
              </div>


              <div class="row  " >
                <div class="col-12">
                  <label for="exampleTitle">Комментарий </label>

                  <textarea class="form-control w-100" required id="exampleTitle" v-model="newComment.comment"
                      placeholder="Введите комментарий"></textarea>
                </div>
                <div class="col-12">


                  <button class=" btn side4 lead_add_comment_btn"   @click="sendComment">Написать<br> комментарий</button>
                </div>
              </div>
            </div>

          </div>
<!--          <div class="col-lg-2">-->
<!--            <h2>Виджеты</h2>-->
<!--            <div class="row widgets_div">-->

<!--            </div>-->
<!--          </div>-->
        </div>


        </div>

      </div>

  </section>

</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Api from "@/models/Api";
import Modal from "@/components/Modal";
import vueKanban from 'vue-kanban'
import Editorjsrender from "@/models/Editorjsrender";
import VueTagsInput from '@johmun/vue-tags-input';
import Editorjsinput from "@/models/Editorjsinput";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "home",

  data() {

    var app = this;

    return {
      "history_type":"all",
      "top_nav_bar_action":"history",
      'top_nav_sub_action':"addcomment",
      "newemail":{
        "subject":null,
        "text":null,
      },
      "newtask":{
        "type_id":null,
        "text":null,
        "date_to":null,
        "responsible_id":null,
      },
      'isemail':false,
      "is_edit_lead":false,
      "base_url":"",
      "telegram_bot":"",
      "task_results":[],
      "developer_user":null,
      "widgets":[],
      "comments":[],
      "newComment":{},
      "new_comment_is_error":false,
      "new_comment_error":null,
      "new_task_is_error":false,
      "new_task_error":null,
      "write_email_is_error":false,
      "write_email_error":null,
      'projects':[],
      "custom_fields":[],
      "history":[],
      "all_objects":[],
      "task_types":[],
      "image_url":null,
      "user":null,
      "lead":null,
      "islogin":false,
      "is_load":false,
      is_load_error:false,
      load_error:'',
      'link_tg_verification':null,
      'link_tg_on_offer_project':null,
      "statuses": [],
      "users":[],
      "categorys":[],
      "developers":[],
      tag: '',
      tags: [],
      'iserror_offer':false,
      'error_offer_message':'',
      'tabs':[],
      'current_tab':0,
      "currencys":null,



    }
  },
   mounted: function () {


    var app = this;

    let id = app.$route.params.id;
     app.telegram_bot = Vue.config.TG_BOT;

    if (app.$store.getters.ISAUTH) {
      var tmpUser = app.$store.getters.USER;

      app.user = tmpUser;
      app.islogin = true;


    }
    app.loadLead(id);








  },
  methods: {
    loadLead(id){
      var app=this;

      Api.loadLead(id,function(data){
        app.image_url = Vue.config.IMAGE_URL;
        app.widgets=data.widgets;
        if(data.developer_user){
          app.developer_user=data.developer_user;
        }
        app.isemail=data.isemail;
        app.currencys=data.currencys;

        if(data.link_tg_verification){
          app.link_tg_verification=data.link_tg_verification;
        }
        if(data.link_tg_on_offer_project){
          app.link_tg_on_offer_project=data.link_tg_on_offer_project;
        }

        app.lead=data.lead;
        app.tabs=data.tabs;
        app.users=data.users;
        app.all_objects=data.all_objects;
        app.developers=data.developers;
        app.history=data.history;
        app.comments=data.comments;
        app.projects=data.projects;
        app.task_types=data.task_types;
        app.tags=[];
        if(data.lead.tags.length>0){
          var data_tags=data.lead.tags;
          data_tags.forEach((element) => {

            var new_el={"text":element};
            app.tags.push(new_el);
          })
        }


        app.lead.link=Vue.config.BASE_URL_FRONT+"confirm/"+data.lead.secretId;

        if(data.lead.lead_data && data.lead.lead_data.length>0){
          var lead_data=data.lead.lead_data;

          lead_data.forEach((element) => {
            if(element.value){
              app.custom_fields[element.name]={value:element.value};
            }else if(element.type=="multi"){
              app.custom_fields[element.name]={value:[]};
            }else {
              app.custom_fields[element.name]={value:""};
            }
          })

          if(app.widgets.length>0){
            var newlead=data.lead;
            newlead.custom_fields=app.custom_fields;
            window.lead_data=newlead;
            var widgets=app.widgets;
            widgets.forEach((element) => {
              let recaptchaScript = document.createElement('script')
              recaptchaScript.setAttribute('src', element.url_widget+"?v="+Math.random())
              document.head.appendChild(recaptchaScript)
            })

          }


        }
        app.statuses=data.statuses;
        app.categorys=data.categorys;
        app.is_load=true;
      },function(err_message){
        app.is_load=false;
        app.is_load_error=true;
        app.load_error=err_message;
      });
    },
    changeCurrentTab(tab){
      var app=this;
      app.current_tab=tab;
    },
    changeActionNavBar(action){
      var app=this;
      app.top_nav_sub_action=action;
    },
    changeTopNavBar(action){
      var app=this;
      app.top_nav_bar_action=action;
    },
    returnBack(){
      var app=this;
      app.$router.push({name: 'funnel', params: {id: app.lead.funnel_id, "rand": Math.random()}});
    },
    onSaveOffer(){
      var app=this;
      app.$refs.editorjs.save(function(editor_js_data){


        var newPost = {}
        newPost.json = editor_js_data;
        var lead_id=app.lead.id;
        Api.updateLead(newPost,lead_id, function (data) {
          app.iserror_offer=false;

          //app.$router.push({name: 'lead', params: {id: data.lead_id, "rand": Math.random()}});
          //document.location.reload();
          app.is_load=false;
          app.loadLead(lead_id);

        },function(error){
          app.iserror_offer = true;
          app.error_offer_message = error;
        });

      });
    },
    changeResponsible(){
      var responsible_id=this.lead.responsible_id;
      var app=this;
      var lead_id=app.lead.id;

      var  json={
        "responsible_id":responsible_id
      };
      app.is_load=false;
      Api.updateLead(json,lead_id,function(data){
        app.loadLead(lead_id);
      },function(error){
        alert(error);
      });
    },
    changeStatus(){
      var status_id=this.lead.status_id;
      var app=this;
      var lead_id=app.lead.id;

      var  json={
        "status_id":status_id
      };
      app.is_load=false;
      Api.updateLead(json,lead_id,function(data){
        app.loadLead(lead_id);
      },function(error){
        alert(error);
      });
    },
    tagsChanged(newtags){
      var tags=[];
      if(newtags.length>0){
        newtags.forEach((element) => {
          tags.push(element.text);
        });
        this.tags=newtags;

        var app=this;
        var lead_id=app.lead.id;

        var  json={
         "tags":tags
        };
        app.is_load=false;
        Api.updateLead(json,lead_id,function(data){
          app.loadLead(lead_id);
        },function(error){
          alert(error);
        });
      }

    },
    setFinishTask(task_id){
      var result="";

      var app=this;
      if(app.task_results[task_id] && app.task_results[task_id].length>0){
        var task_data={};
        task_data.task_id=task_id;
        task_data.result=app.task_results[task_id];
        Api.setFinishTask(task_data, app.lead.id, function (all_objects) {
          document.location.reload();
        },function (message) {

        });
      }


    },
    deleteTask(task_id){
      var app=this;
      Api.deleteLeadTask(task_id, app.lead.id, function (all_objects) {
        document.location.reload();
      },function (message) {

      });
    },
    sendEmail(event){
      event.preventDefault();
      var app = this;
      var newemail=app.newemail;
      app.is_load=false;
      Api.sendEmailLead(newemail, app.lead.id, function (all_objects) {
        app.is_load=true;
        document.location.reload();
        app.write_email_is_error = false;

        app.newComment.comment = "";
        //app.delete(app.all_objects,[]);
        if(app.all_objects.length>0){
          app.all_objects.forEach(function (item, index, object) {
            object.splice(index, 1);
          });
        }
        app.all_objects=[];
        if(all_objects.length>0){
          all_objects.forEach(function(item){
            app.all_objects.push(item);
          })
        }

        app.all_objects=all_objects;
      }, function (message) {
        app.is_load=true;
        app.write_email_is_error = true;
        app.write_email_error= message;
      })

    },
    sendTask(event){
      event.preventDefault();
      var app = this;
      var newtask = app.newtask;
      Api.addLeadTask(newtask, app.lead.id, function (all_objects) {
        document.location.reload();
        app.iserror = false;

        app.newComment.comment = "";
        //app.delete(app.all_objects,[]);
        if(app.all_objects.length>0){
          app.all_objects.forEach(function (item, index, object) {
            object.splice(index, 1);
          });
        }
        app.all_objects=[];
        if(all_objects.length>0){
          all_objects.forEach(function(item){
            app.all_objects.push(item);
          })
        }

        app.all_objects=all_objects;
      }, function (message) {
        app.new_task_is_error = true;
        app.new_task_error= message;
      })
    },
    sendLinkToClient(){
      var app=this;
      Api.sendLinkToClient(app.lead.id,function(data){
        ///document.location.reload();
        alert('успешно');
      },function (message) {
        alert(message);
      });
    },
    sendCommentTelegram(event){
      event.preventDefault();
      var app = this;
      var newComment = app.newComment;
      newComment.is_telegram=1;
      Api.addLeadComment(newComment, app.lead.id, function (all_objects) {
        document.location.reload();
        app.iserror = false;

        app.newComment.comment = "";
        //app.delete(app.all_objects,[]);
        if(app.all_objects.length>0){
          app.all_objects.forEach(function (item, index, object) {
            object.splice(index, 1);
          });
        }
        app.all_objects=[];
        if(all_objects.length>0){
          all_objects.forEach(function(item){
            app.all_objects.push(item);
          })
        }

        app.all_objects=all_objects;
      }, function (message) {
        app.iserror = true;
        app.error_message = message;
      })

    },
    sendComment(event) {
      event.preventDefault();
      var app = this;
      var newComment = app.newComment;
      Api.addLeadComment(newComment, app.lead.id, function (all_objects) {
        document.location.reload();
        app.iserror = false;

        app.newComment.comment = "";
        //app.delete(app.all_objects,[]);
        if(app.all_objects.length>0){
          app.all_objects.forEach(function (item, index, object) {
            object.splice(index, 1);
          });
        }
        app.all_objects=[];
        if(all_objects.length>0){
          all_objects.forEach(function(item){
            app.all_objects.push(item);
          })
        }

        app.all_objects=all_objects;
      }, function (message) {
        app.iserror = true;
        app.error_message = message;
      })


    },
    showForm(){
      var app=this;
      app.is_edit_lead=true;
    },
    hideForm(){
      var app=this;
      app.is_edit_lead=false;
    },
    saveLead(){
      var app=this;
      var lead_id=app.lead.id;
       var custom_fields=app.lead.lead_data;
    var  json={
      "lead_data":custom_fields,
      "category_id":app.lead.category_id,
      "status_id":app.lead.status_id,
      "tags_text":app.lead.tags_text,
      "responsible_id":app.lead.responsible_id,
      "invoice_title":app.lead.invoice_title,
     }
     if(app.lead.currency
     && app.lead.sum
     && app.lead.type_invoice
     ){
       json["currency"]=app.lead.currency;
       json["sum"]=app.lead.sum;
       json['type_invoice']=app.lead.type_invoice;
     }
     if(app.lead.developer_username){
      json["developer_username"]=app.lead.developer_username;
     }else {
       json["developer_username"]=0;
     }
     app.is_load=false;
     Api.updateLead(json,lead_id,function(data){
      app.is_load=true;
     app.history=data.history;
     app.widgets=data.widgets;
     },function(error){
       alert(error);
     });
    }

  },
  components: {Modal,'editorjsrender': Editorjsrender,'editorjsinput': Editorjsinput, VueTagsInput,LoadingBlock}
};
</script>